import Vue from 'vue';

export default () => {
	const notifySuccess = (message, timeout = 10000, type = 'default') => {
		Vue.prototype.$notify({
			message,
			timeout,
			icon: (type == 'success') ? 'ni ni-check-bold' : 'ni ni-bell-55',
			type: type,
		});
	}
	const notifyError = (message, timeout = 10000, type = 'warning') => {
		Vue.prototype.$notify({
			message,
			timeout,
			icon: 'ni ni-bulb-61',
			type: type,
		});
	}
	const redErrorNotify = (error_message) => {
		notifyError(error_message, 1000, 'danger')
	}
	const errorFunction = (error, message = null, module = null) => {
		if (error == 403) {
			notifyError("You dont have Access to this Module or Function in the Module. Please Contact Administrator.")
			return
		}
		if (!_gHlp.isEmpty(message)) {
			notifyError(message)
			return
		}

		//ERROR RESPONSE
		if (!_gHlp.isEmpty(error)) {

			if (!_gHlp.isEmpty(error.response)) {
				let response_code = (!_gHlp.isEmpty(error.response.status)) ? error.response.status : null;
				let response_data = (!_gHlp.isEmpty(error.response.data)) ? error.response.data : null;
				let response_errors = (!_gHlp.isEmpty(response_data) && !_gHlp.isEmpty(response_data.errors)) ? response_data.errors : null;

				//IF HAS ERROR ARRAY
				if (!_gHlp.isEmpty(response_errors)) {
					let errorList = '<br>'
					let noError = 0
					Object.keys(response_errors).forEach(function (key) {
						Object.keys(response_errors[key]).forEach(function (value) {
							noError = noError + 1
							errorList = errorList + 'No. ' + noError + ' : ' + (response_errors[key][value])
							errorList = errorList + '<br>'
						});
					});

					notifyError('<b>Input Validation Warning :  </b>  ' + errorList)
					return;
				}

				if (response_code == 401) {
					notifyError('<b>System Warning : </b> - Your session has been end, please re-login.', 15000, 'danger');
					return;
				}
				//IF SERVER ERROR
				if ((response_code === 500) && !_gHlp.isEmpty(response_data)) {

					if (!_gAuth.appIsDemo()) {
						notifyError('<b>System Error : </b> - The System is Currently Busy or Un-Available.', 15000, 'danger');
						return;
					}

					let { message, file, line } = response_data;
					var error = message
					if (file && line) {
						error = message + '<br> File: ' + file.split("/").pop() + '<br>Line: ' + line
					}
					notifyError(error)
					return;
				}

				//NO HAVE PERMISSION
				if (response_code == 403) {
					if (!_gHlp.isEmpty(module)) {
						notifyError('<b>Insufficient Permissions to : ' + module + '</b> - You dont have Access to this Module or Function in the Module. Please Contact Administrator.')
						return;
					} else {
						notifyError('<b>Insufficient Permissions</b> - You dont have Access to this Module or Function in the Module. Please Contact Administrator.')
						return;
					}
				}

				if (response_code == 404) {
					if (!_gHlp.isEmpty(module)) {
						notifyError('<b>Try request to : ' + module + '</b> - The data you requested is not available')
						return;
					} else {
						notifyError('<b>No Available Services</b> - The data you requested is not available.')
						return;
					}
				}

				//IF NOTFOUND
				if ((response_code >= 400) && !_gHlp.isEmpty(response_data)) {
					if (!_gHlp.isEmpty(response_data.message)) {
						notifyError(response_data.message)
						return;
					}
					if (_gHlp.isEmpty(response_data.message) && !_gHlp.isEmpty(response_data.exception)) {
						notifyError(response_data.exception)
						return;
					}
					if (!_gHlp.isEmpty(error.message)) {
						notifyError(error.message)
						return;
					}
				}

				//IF UNKNOW ERROR
				if (!_gHlp.isEmpty(response_data)) {
					if (!_gHlp.isEmpty(response_data.message)) {
						notifyError(response_data.message)
					} else {
						notifyError("Something went wrong!. Please Contact Administrator.")
					}
					return;
				}
			}
			if (!_gHlp.isEmpty(error.message)) {
				notifyError(error.message)
				return
			}

			if (_gHlp.isEmpty(error.response)) {
				notifyError("Something went wrong!. Please Contact Administrator.")
				return
			}
		}
	}
	const underDevelopment = () => {
		notifyError('<b>This Function / Module is currently Under Development, Please come back later.</b>')
	}
	const preventNonNumericInput = (event) => {
		const keyCode = event.keyCode || event.which;
		const keyValue = String.fromCharCode(keyCode);
		const currencyRegex = /^[\d.,$]+(\.[\d.,$]+)?$/;
		const allowedKeys = [8, 37, 38, 39, 40, 46];
		if (keyCode !== 190 && !currencyRegex.test(keyValue) && !allowedKeys.includes(keyCode)) {
			event.preventDefault();
		}
	}
	const cLog = (message) => {
		if (_gAuth.appIsDemo()) console.log(message);
	}
	return {
		notifySuccess,
		notifyError,
		redErrorNotify,
		errorFunction,
		underDevelopment,
		preventNonNumericInput,
		cLog
	}
}

